import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { Template } from '../templates/template.model';

@Injectable()
export class QCService {

  apiHost = environment.apiHost;
  signedIn: boolean = this.authService.signedIn;
 
  constructor(
    private http: HttpClient,
    private authService: AuthService) { }

  getRecentReports(page: number, archived: boolean): Observable<any> {
    let query = "?workflow_id=95&result_size=25&sort_by=last_updated&sort_order=desc";
    query += "&page="+page;
    if (archived) {
      query += "&archived=true";
    }
    return this.http.get(this.apiHost+"/templates"+query).map(
      (data: any) => {
        let total = data.total_templates;
        let templates = data.templates.map((t) => Template.fromRecord(t))
        return {templates: templates, total: total};
      }
    ).catch((error) => {
        if (error.status === 401) {
          this.authService.signIn()
        }
        return Observable.throw(error.status);
      }
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/qc/qc.service.ts